<template>
  <div class="detail-list">
    <table class="table custom-table">
      <thead class="custom-table-title">
        <tr>
          <th scope="col">商品</th>
          <th scope="col">商品編號</th>
          <th scope="col">商品名稱</th>
          <th scope="col">規格</th>
          <th scope="col" v-if="modalType === 'additionalPrice'">單價</th>
          <th scope="col" v-if="modalType === 'additionalPrice'">加購價</th>
          <th scope="col">數量</th>
        </tr>
      </thead>
      <tbody class="custom-table-body">
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    modalType: {
      type: String,
      default: ''
    }
  }
};
</script>
